<template>
  <div class="lottery_image_title_bg">
    <img
      class="lottery_title_image"
      src="../../assets/lottery/decoration_left.png"
    />
    <p class="lottery_title">{{ titleName }}</p>
    <img
      class="lottery_title_image"
      src="../../assets/lottery/decoration_right.png"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    titleName: String
  }
})
export default class LotteryTitle extends Vue {}
</script>

<style scoped lang="less">
/// 本期中奖名单 - title
.lottery_image_title_bg {
  padding: 0px;
  width: 100%;
  display: flex;
  text-align: center;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  .lottery_title {
    text-align: center;
    margin: 0 auto;
    margin-left: 6px;
    margin-right: 6px;
    font-size: 16px;
    font-weight: bold;
    color: #111111;
  }
  .lottery_title_image {
    height: 20px;
  }
}
</style>
